import { Classroom } from '@/api/classroom'

const state = () => ({
    certificates: [],
    certificatesPagination: {},
    oldCertificates: [],
    oldCertificatesPagination: {},
    isLoadingCertificate: false,
    isSuccessCertificate: true,
    messageCertificate: '',
    certificateDetail: {},
    isLoadingOpenCertificate: false,
    isSuccessOpenCertificate: true,
    userCertificate: [],
    certificateUserDetail: {
        perPage: 10,
        first: 0,
    },
})

const getters = {
    certificatesList: state => state.certificates,
    certificatesPagination: state => state.certificatesPagination,
    oldCertificatesList: state => state.oldCertificates,
    oldCertificatesPagination: state => state.oldCertificatesPagination,
    isLoadingCertificate: state => state.isLoadingCertificate,
    isSuccessCertificate: state => state.isSuccessCertificate,
    messageCertificate: state => state.messageCertificate,
    certificateDetail: state => state.certificateDetail,
    isLoadingOpenCertificate: state => state.isLoadingOpenCertificate,
    isSuccessOpenCertificate: state => state.isSuccessOpenCertificate,
    historyCertificate: state => state.userCertificate,
    certificateUserDetail: state => state.certificateUserDetail,
}

const actions = {
    async fetchAllCertificates({ commit }, query = null) {
        let page = 1
        let perPage = 10
        let search = ''
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            search = query.search
        }
        commit('setIsLoadingCertificate', true)
        await Classroom.getAllCertificate(perPage, page, search)
            .then(res => {
                commit('setCertificates', res.data.data)
                const pagination = {
                    total: res.data.pages.total,
                    per_page: res.data.pages.per_page,
                    current_page: res.data.pages.current_page,
                    from: res.data.pages.from,
                }
                commit('setCertificatesPagination', pagination)
                commit('setIsLoadingCertificate', false)
            })
            .catch(error => {
                console.log(error)
                commit('setIsLoadingCertificate', false)
            })
    },
    async fetchUserCertificate({ commit }, id) {

        commit('setIsLoadingCertificate', true)

        await Classroom.getUserCertificate(id)
            .then(response => {
                commit('setUserCertificate', response.data.data)
                commit('setIsLoadingCertificate', false)
            })
            .catch(error => {
                console.log(error)
                commit('setIsLoadingCertificate', false)
            })
    },
    async fetchAllOldCertificates({ commit }, query) {
        let page = 1
        let perPage = 10
        let search = ''
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            search = query.search
        }
        commit('setIsLoadingCertificate', true)
        await Classroom.getAllOldCertificate(perPage, page, search)
            .then(res => {
                commit('setOldCertificates', res.data.data)
                const pagination = {
                    total: res.data.pages.total,
                    per_page: res.data.pages.per_page,
                    current_page: res.data.pages.current_page,
                    from: res.data.pages.from,
                }
                commit('setOldCertificatesPagination', pagination)
                commit('setIsLoadingCertificate', false)
            })
            .catch(error => {
                console.log(error)
                commit('setIsLoadingCertificate', false)
            })
    },
    openCertificate({ commit }, code) {
        commit('setIsLoadingOpenCertificate', true)
        return new Promise((resolve, reject) => {
            Classroom.openCertificate(code)
                .then(res => {
                    if (res.data.success) {
                        commit('setCertificateDetail', res.data.data)
                        commit('setSuccessOpenCertificate', true)
                        commit('setMessageCertificate', 'Membuka Sertifikat')
                    } else {
                        commit('setSuccessOpenCertificate', false)
                        commit('setIsLoadingOpenCertificate', false)
                        commit('setMessageCertificate', 'Terjadi Kesalahan')
                    }
                    resolve()
                })
                .catch(error => {
                    commit('setSuccessOpenCertificate', false)
                    commit('setIsLoadingOpenCertificate', false)
                    commit('setMessageCertificate', error)
                    reject(error)
                })
        })
    },
    saveCertificateUserDetail({commit}, pages) {
        commit('setCertificateUserDetail', pages)
    },
}

const mutations = {
    setCertificates: (state, certificates) => {
        state.certificates = certificates
    },
    setUserCertificate: (state, userCertificate) => {
        state.userCertificate = userCertificate
    },

    setCertificatesPagination: (state, pagination) => {
        state.certificatesPagination = pagination
    },

    setOldCertificates: (state, oldCertificates) => {
        state.oldCertificates = oldCertificates
    },

    setOldCertificatesPagination: (state, pagination) => {
        state.oldCertificatesPagination = pagination
    },

    setIsLoadingCertificate: (state, isLoadingCertificate) => {
        state.isLoadingCertificate = isLoadingCertificate
    },

    setSuccessCertificate: (state, isSuccess) => {
        state.isSuccessCertificate = isSuccess
    },

    setMessageCertificate: (state, message) => {
        state.messageCertificate = message
    },

    setCertificateDetail: (state, detail) => {
        state.certificateDetail = detail
    },

    setIsLoadingOpenCertificate: (state, isLoading) => {
        state.isLoadingOpenCertificate = isLoading
    },

    setSuccessOpenCertificate: (state, success) => {
        state.isSuccessOpenCertificate = success
    },

    setCertificateUserDetail: (state, pages) => {
        state.certificateUserDetail = pages
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}